import { POST_METHOD } from './ApiMethods';

export const postLogin = async (email = '', password = '') => {
  try {
    let response = await POST_METHOD('login', {
      email: email,
      password: password,
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const postLogout = async (id) => {
  try {
    let response = await POST_METHOD('logout', {candidate_id: id});
    return response;
  } catch (error) {
    return error;
  }
};
